/* import __COLOCATED_TEMPLATE__ from './delete-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();